// EmployeesDetail view
import React from 'react'
import { Col, Container, Input, InputGroup, Row } from 'reactstrap' 
 

const EmployeesDetail = () => { 

    document.title="EmployeesDetail";
    return (
        <React.Fragment> 
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 pt-4 mb-4">
                                    <div className="mb-sm-5 pb-sm-4 pb-5">
                                    EmployeesDetail
                                    </div> 
                                </div>
                            </Col>
                        </Row>

                    </Container>

                </div> 
        </React.Fragment>
    )
}

export default EmployeesDetail